import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

export function IconArrow(props: Props) {
  const { width = 10, height = 10 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M1.66675 3.33334L5.00008 6.66668L8.33341 3.33334"
        stroke="#969696"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
